import script from "./NewsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsList.vue?vue&type=script&setup=true&lang=js"

import "./NewsList.vue?vue&type=style&index=0&id=484413c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-484413c2"]])

export default __exports__